export default __webpack_public_path__ + "static/media/BW.781d39c8.svg";